const HSW_INSTRUCTION_SET = {
  off: ["0x00", "0x20", "0x03", "0x00"],
  on: ["0x00", "0x20", "0x02", "0xFF"],
};

export { HSW_INSTRUCTION_SET };
